module.exports = __webpack_public_path__ + "img/u2063.021f1963.png";